import React from 'react';

export default function FwFilterIcon({ color = 'currentColor', fontSize = '16px', customClass }) {
  return (
    <>
      <i className={`fas fa-filter ${customClass} `} style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
